import styled from 'styled-components';

export const SociologicalResearchPartnersStyles = styled.div`
  padding: 50px 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 48px;

  .partner-quee {
    width: 100%;

    div {
      &::before {
        display: none;
      }
      &::after {
        display: none;
      }
    }
  }

  .logoWrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;

    border: 2px solid #F05A25;
    width: 370px;
    height: 370px;
    border-radius: 100%;
    font-weight: 700;
    font-size: 40px;
    line-height: 120%;

    color: #000000;

    margin-left: -50px;

    img {
      object-fit: contain;
      max-width: 60%;
    }

    @media (max-width: 1000px) {
      height: 197px;
      width: 197px;

      margin-left: -30px;
      font-size: 21px;
    }

    @media (max-width: 600px) {
      height: 200px;
      width: 200px;

      margin-left: -30px;
      font-size: 21px;
    }
  }
`;
